import * as React from "react";

function SvgVitally(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 347 347"
      {...{ ...props, ref }}
    >
      <style />
      <g id="Vitally_svg__Layer_3">
        <linearGradient
          id="Vitally_svg__SVGID_1_"
          gradientUnits="userSpaceOnUse"
          x1={123.308}
          y1={135.815}
          x2={326.953}
          y2={135.815}
        >
          <stop offset={0} stopColor="#8be9e8" />
          <stop offset={1} stopColor="#60e1e0" />
        </linearGradient>
        <path
          fill="url(#Vitally_svg__SVGID_1_)"
          d="M276 199.5l51-51-76.4-76.3-127.3 127.3z"
        />
        <linearGradient
          id="Vitally_svg__SVGID_2_"
          gradientUnits="userSpaceOnUse"
          x1={72.394}
          y1={174}
          x2={276.041}
          y2={174}
        >
          <stop offset={0} stopColor="#69adfd" />
          <stop offset={1} stopColor="#3791fc" />
        </linearGradient>
        <path
          fill="url(#Vitally_svg__SVGID_2_)"
          d="M199.7 275.8L72.4 148.5l76.4-76.3L276 199.5z"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgVitally);
